import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import DataTable from "react-data-table-component";
import moment from "moment";
import OverlayTriggerTooltip from "components/common/OverlayTriggerTooltip";

export default function RuleHistoryTab({ ruleHistory }) {
  const [t] = useTranslation();
  const customStyles = {
    headCells: {
      style: {
        fontSize: "14px",
        padding: "0.75rem",
        verticalAlign: "middle",
        color: "#004e5c",
        fontWeight: 800,
      },
    },
    cells: {
      style: {
        fontSize: "14px",
        padding: "0.75rem",
        verticalAlign: "middle",
      },
    },
  };
  const columns = useMemo(
    () => [
      {
        name: t("createRuleEngine.settingsTab.ruleName.label"),
        selector: (row) => (
          <OverlayTriggerTooltip
            tooltipText={row.name}
            triggerEl={<span>{row.name}</span>}
            placement="top-start"
          />
        ),
        sortable: false,
        minWidth: "200px",
        className: "",
      },
      {
        name: t("createRuleEngine.settingsTab.rulesDescription.label"),
        selector: (row) =>
          row.rulesDescription ? (
            <OverlayTriggerTooltip
              tooltipText={row.rulesDescription}
              triggerEl={<span>{row.rulesDescription}</span>}
              placement="top"
            />
          ) : (
            "-"
          ),
        sortable: false,
        minWidth: "400px",
      },
      {
        name: t("createRuleEngine.settingsTab.routingUser.ruleType"),
        selector: (row) => row.rulesTypeLabel,
        sortable: false,
        minWidth: "150px",
      },
      {
        name: t("versionsForm.columns.updatedBy"),
        selector: (row) => row.createdBy,
        sortable: false,
        minWidth: "200px",
      },
      {
        name: t("versionsForm.columns.updatedAt"),
        selector: (row) => moment(row.createdAt).format("MMM D YYYY, HH:mm"),
        sortable: false,
        minWidth: "250px",
      },
    ],
    []
  );
  return (
    <div className="table-responsive">
      <DataTable
        responsive
        persistTableHead
        keyField={"rulesId"}
        columns={columns}
        data={ruleHistory}
        pagination
        striped
        customStyles={customStyles}
      />
    </div>
  );
}
